export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};

export const SCREEN = {
  SM: 600,
  MD: 960
};

export const STORAGE = {
  // sas: '?sv=2020-02-10&ss=bf&srt=sco&sp=rwdlacx&se=2022-04-02T00:08:09Z&st=2021-04-01T16:08:09Z&spr=https&sig=5j09uEMaQCWq7tCRNwgiqw7MUb5Ryux7cH7MUqKEUfk%3D',
  // sas: '?sv=2020-08-04&ss=bf&srt=sco&sp=rwdlacitfx&se=2025-03-08T08:44:00Z&st=2022-03-08T04:00:00Z&spr=https&sig=HOL%2FI71Oiauyg3nEbJ3i5opBOZfL%2FW7Fgow38iQLiQE%3D',
  // sas: '?sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2027-03-10T11:05:59Z&st=2026-02-09T02:50:59Z&spr=https&sig=GHqbW%2B1jyzzyiO%2BjZphhjZhULqqJYk2bhUKvhUoybX0%3D',
  sas: '?sv=2024-11-04&ss=bfqt&srt=co&sp=rwdlacupiytfx&se=2029-03-07T13:19:55Z&st=2026-03-07T05:04:55Z&spr=https&sig=49ydBDPrSG8ZgEJ5BR1fHBw52tSA0UJL09S%2Br1u3O0A%3D',
  container: '-salesperson-',
};

export const POST_HEADER = {
  headers: {
    apiKey: process.env.REACT_APP_DATA_API_KEY,
  }
};

export const FORM_POST_HEADER = {
  headers: {
    apiKey: process.env.NEXT_PUBLIC_FORM_KEY || process.env.REACT_APP_FORM_KEY,
  }
};

export const DATE_TIME_FORMAT = 'MM/DD/yyyy hh:mma';

export const TIME_FORMAT = 'hh:mma';

export const REQUIRE_SUBSCRIPTION_DATE = '2022-06-06';

// CP support's texting number, as shown to consultants. Matches the
// server's CP_SUPPORT_TEXT_NUMBER (constants/misc.js). Older screens still
// carry their own copies of it.
export const CP_SUPPORT_TEXT_NUMBER = '(317) 456-5610';

export const SCREEN_NAMES = {
  CONTACT_LIST: 'Contact List',
  EVENT_GUEST_LIST: 'Event Guest List',
  EVENT_LIST: 'Event List',
  GROUP_LIST: 'Group List',
  GROUP_CONTACT_LIST: 'Group Contact List',
};
